exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".grid-content[data-v-e2853d8e]{text-align:center}.grid-image[data-v-e2853d8e]{width:45px;height:45px;border-radius:15%}.ellipsis[data-v-e2853d8e]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.row-bg[data-v-e2853d8e]{padding:10px 0}.overlay[data-v-e2853d8e]{position:absolute;top:0;left:0;width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;cursor:pointer;opacity:0;transition:opacity .3s ease;background-color:rgba(0,0,0,.5)}.icon[data-v-e2853d8e]{font-size:36px;color:#fff}.overlay.active[data-v-e2853d8e]{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e2853d8e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/digitizedcampus/AppDialog.vue
// module id = 2109
// module chunks = 0